import ActionTypes from '@/febos/chile/dnt/mixins/ActionTypes';
import { getSheetsConfig } from '@/febos/servicios/api/dnt.api';

export default {
  data() {
    return {
      disableSignaturePosition: false,
      loadingActionsOffice: false,
      documentHasOficeActions: false,
      step: {
        office: {
          list: [],
          selected: null,
          documentInfo: null
        },
        actions: []
      }
    };
  },
  methods: {
    async checkIfDocumentHasAutomaticNumerationActions(option) {
      this.disableSignaturePosition = false;
      this.removeActionsStepOffice();
      this.step.office.documentInfo = null;
      this.step.office.selected = null;
      this.documentHasOficeActions = false;
      if (option && option.extra?.uso.numeracion) {
        const {
          numInt: numerationInternal = false,
          numOf: numerationOficial = false
        } = option.extra;
        if (numerationInternal && numerationOficial) {
          // Todo documento no es numerable por aqui https://febos.slack.com/archives/G01FRN6RVEV/p1648744823157399
        } else if (numerationInternal) {
          this.documentHasOficeActions = true;
          this.loadingActionsOffice = true;
          if (!this.step.office.list.length) {
            await this.fetchOffices([{ key: 'isOffice', filter: 'esOficina:Y|tipo:int' }]);
            this.setListOfficesFromListState();
          }
          this.setActionsDesignedOffice({ numerationRequired: true, dateRequired: true });
          this.loadingActionsOffice = false;
          return true;
        } else if (numerationOficial) {
          this.documentHasOficeActions = true;
          this.loadingActionsOffice = true;
          if (!this.step.office.list.length) {
            await this.fetchOffices([{ key: 'isOffice', filter: 'esOficina:Y|tipo:ext' }]);
            this.setListOfficesFromListState();
          }
          this.setActionsDesignedOffice({ numerationRequired: true, dateRequired: true });
          this.loadingActionsOffice = false;
          return true;
        }
      }
      return false;
    },
    setListOfficesFromListState() {
      this.step.office.list = this.officesState.list;
    },
    setActionsDesignedOffice(info) {
      this.step.office.documentInfo = info;
      const listOffices = this.step.office.list;
      if (listOffices.length === 1) {
        const [office] = listOffices;
        this.step.office.selected = office;
        this.addActionsOffice(office, info);
      }
    },
    addActionsOffice(office, info) {
      if (!office) {
        this.removeActionsStepOffice();
        this.onSetSignaturePositionChange(this.step.setSignaturePosition);
      } else {
        if (info.numerationRequired) {
          this.step.actions = this.step.actions.filter(
            (action) => action.action !== ActionTypes.NUMERATION
          );
          this.step.actions.push({
            id: office.id,
            action: ActionTypes.NUMERATION,
            positionRequired: true
          });
          this.step.setSignaturePosition = true;
          this.disableSignaturePosition = true;
          this.onSetSignaturePositionChange(this.step.setSignaturePosition);
        }
        if (info.dateRequired) {
          this.step.actions = this.step.actions.filter(
            (action) => action.action !== ActionTypes.DATE
          );
          this.step.actions.push({
            id: office.id,
            action: ActionTypes.DATE,
            positionRequired: true
          });
          this.step.setSignaturePosition = true;
          this.disableSignaturePosition = true;
          this.onSetSignaturePositionChange(this.step.setSignaturePosition);
        }
      }
    },
    removeActionsStepOffice() {
      const info = this.step.office.documentInfo;
      if (info) {
        if (info.numerationRequired) {
          this.step.actions = this.step.actions.filter(
            (action) => action.action !== ActionTypes.NUMERATION
          );
        }
        if (info.dateRequired) {
          this.step.actions = this.step.actions.filter(
            (action) => action.action !== ActionTypes.DATE
          );
        }
      }
    },
    async validNumerationActionConfigDocNum() {
      if (this.step.actions && this.step.actions.length > 0) {
        const numerationAction = this.step.actions.find(
          (actionItem) => actionItem.action === ActionTypes.NUMERATION
        );
        if (numerationAction) {
          const { data: { configFolios = [] } } = await getSheetsConfig({
            tipoDocId: this.step.documentTypeId,
            alcanceId: numerationAction.id
          });
          if (!configFolios.length) {
            return false;
          }
        }
      }
      return true;
    }
  }
};
